import { Controller } from "@hotwired/stimulus";

// Keeps a scrollable element's reading position stable across Turbo Frame
// re-renders. The feed item modal re-renders its whole `feed_modal_content`
// frame on every Find search edit, which replaces the scroll container and
// would otherwise reset it to the top.
//
// Attach to the turbo-frame element (it persists across frame navigations,
// so the saved position survives the re-render) and mark the scrollable
// element with `data-preserve-scroll-target="scroller"`.
export default class extends Controller {
  static targets = ["scroller"];

  save() {
    this.savedScrollTop = this.hasScrollerTarget ? this.scrollerTarget.scrollTop : null;
  }

  restore() {
    if (this.savedScrollTop == null) { return; }
    if (!this.hasScrollerTarget) { return; }

    this.scrollerTarget.scrollTop = this.savedScrollTop;
  }
}
